import React, {useState} from 'react';
import './style.css';
import Logo from "../../../assets/images/Vector.png";
import ChatSnap from "../../../assets/images/Group.png";
import { ReactComponent as ChatImg } from "../../../assets/images/Group.svg";
import { ReactComponent as TradeMark } from "../../../assets/images/trademark.svg";
import { ReactComponent as Mic } from "../../../assets/images/mic.svg";
import { ReactComponent as Emoji } from "../../../assets/images/emoji.svg";
import { ReactComponent as Attachment } from "../../../assets/images/attachment.svg";
import { ReactComponent as Bubble } from "../../../assets/images/bubble.svg";
import Input from '../../common/InputField';

function PreviewTwo({ color, gradientOne, gradientTwo, alignment, preChat, guestMode, bubble, nameRequired, emailRequired, welcomeText }) {

  return (
    <div className="previewTwoWidget">

      <div style={{ margin: "0 auto", borderRadius: '8px', background: "#fff", minHeight: '276px'}}>

        <div className="defaultColor boxTop" style={{background: color ? color : `linear-gradient(125deg, #e6e6e6 0%, ${gradientOne} 50%, ${gradientTwo} 75%)`, display: 'flex', justifyContent: 'center', alignItems: 'center',  borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}>
          <img className="widgetLogo" src={Logo} alt="Logo" />
        </div>

        <div className='previewTwoCenter'>
        {preChat ? (
        <div className="preChatForm" style={{background: '#fff', opacity: '0.93', display: 'flex', flexDirection: 'column', pading: '1rem', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', width: '90%', margin: '-1rem auto 0 auto', height: 'auto'}}>
          <p className="welcomeText" style={{fontWeight: 'bold', lineHeight: '18px', textAlign: 'center'}}>{welcomeText}</p>
          <p className="fillTxt" style={{lineHeight: '18px', textAlign: 'center'}}>Please Fill in the form below before <br/> start the chat</p>
          

          <label className='req-label-form'>Name:{nameRequired && <span style={{ color: '#FF4D4F' }}>*</span>}</label>
          <input class="form-input-div form-name" placeholder="Enter name" />
          
          <label className='req-label-form'>Email:{emailRequired && <span style={{ color: '#FF4D4F' }}>*</span>}</label>
          <input class="form-input-div form-email" placeholder="Enter email address" />

          <button className="defaultTextColor preChatBtn startChatUser" style={{width: '100%', background: '#fff', color: color ? color : gradientOne, border: '1px solid #ccc', borderRadius: '0.5rem', marginBottom: '5px'}} type="button" >Start the Chat</button>
          {guestMode && (
            <button className="guestChat defaultColor preChatBtn" style={{width: '100%', background: color ? color : gradientOne, color: '#fff', border: 'none', borderRadius: '0.5rem'}} type="button" >Start chat as a Guest</button>
          )} 
        </div>
        ) : (
            <div className="preChatForm" style={{background: '#fff', opacity: '0.93', padding: '1rem', textAlign: 'center', gap: '8px', justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-1rem', pading: '1rem', borderRadius: '0.5rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', marginRight: '1rem', marginLeft: '1rem'}}>
              <p style={{fontWeight: 'bold', lineHeight: '18px'}}>{welcomeText}</p>
              <button className="guestChat defaultColor preChatBtn" style={{width: '100%', background: color ? color : gradientOne, color: '#fff', border: 'none', borderRadius: '0.5rem', marginTop: '5px'}} type="button" >
                Start chat as a Guest
              </button>
            </div>
        )}
        </div>

          <div className="trademark" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'end'}}>
            <TradeMark  />
          </div>

      </div>

      {bubble ? (
      <div className="defaultColor bubble" style={{ float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={Logo} alt="Logo" style={{ height: '2.6vh'}} />
      </div>
      ) : ( 
        <div className="defaultColor bar" style={{  padding: '0 16px 0 12px', float: alignment, marginTop: '0.75rem', background: color ? color : gradientOne, borderRadius: "28px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Logo} alt="Logo" style={{ height: '2.6vh'}} /><span className="barText" style={{paddingLeft: '6px', lineHeight: '18px'}}>Chat with us</span>
        </div>
      )}

    </div>
  )
}

export default PreviewTwo;